import { Injectable } from '@angular/core';
import {
  DetailAccountModel,
  DetailRevolvingCreditModel,
  EthnicGroupModel,
  PcoModel,
  ProductCard,
} from 'src/app/shared/models/abre-cuentas.model';

import { BANK_INFO_CONST, BUSINESS_CONST } from '../../constants/business.constants';
import { RISK_LEVELS } from '../../constants/rate.constants';
import {
  CiiuModel,
  CityModel,
  FinancialModel,
  OfficeModel,
} from '../../models/abre-cuentas.model';
import { ContactModel } from '../../models/contact.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { HelpersService } from '../helpers/helpers-onboarding.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { StringHelperService } from '../helpers/string-helper.service';
import { ValidationHelperService } from '../helpers/validation-helper.service';
import { ParametersService } from '../parameters/parameters.service';
import { RequestService } from '../request/request-onboarding.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { CHANNEL } from '../../constants/channel.constants';
import { LogDeviceModel } from '../../models/log-device.model';
import { CryptoVaultService } from '../external/crypto-vault/crypto-vault.service';
import { ERROR_LIB } from '../../constants/abre-cuentas.constants';
// import { NavigationService } from '../navigation/navigation-onboarding.service';
import { OpEnum } from '../../enums/op.enum';

/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase CaptureService, servicio para enviar la información capturada del prospecto de cliente
 *
 * *CaptureService class definition, service to send client info*
 *
 * @type {class}
 */
export class CaptureService {
  creditGrayZone: any;
  bioCatchService: any;
  productsSelectedMulti: any;
  productPass: any;
  credit_recharge_up_information: any = [];
  /**
   * Constructor de la clase
   *
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @param {RequestService}             requestService
   * @param {AbreCuentasService}         abreCuentasService
   *
   */
  constructor(
    private requestService: RequestService,
    private abreCuentasService: AbreCuentasService,
    private validationHelperService: ValidationHelperService,
    private helperService: HelpersService,
    private stringHelperService: StringHelperService,
    private firmlyApprovedService: FirmlyApprovedService,
    private parametersService: ParametersService,
    private channel: ChannelCommunicatorService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private cipherService: CryptoVaultService,
    // private navigationService: NavigationService
  ) { }

  priority: any = 0;
  /**
   * Código de la respuesta de la solicitud
   *
   * *Response code by the request*
   *
   * @type {string} code
   */
  code: string;
  dataClient: any;
  financialInfo: FinancialModel;
  officeInfo: OfficeModel;
  solicitationId = this.abreCuentasService.getSolicitationId();
  isCardDuality: boolean;
  dataIncome: any;
  variableForControlCall = 0;

  /**
   * Función asíncrona para enviar la información de la ocupacion del cliente
   *
   * *Async Function that sends occupation client info*
   *
   * @type {function}
   * @returns {Promise}
   */
  async sendProspectOccupation(): Promise<any> {
    const body = {
      occupation_id: 1,
      ciiu: '010',
      product_type: 'NOMINA',
      benefit_code: 'NODEFINIDO',
    };

    const parms = {
      main_activity_id: 1,
      first_name: this.abreCuentasService.getDocumentInfo().firstname,
      first_surname: this.abreCuentasService.getDocumentInfo().primary_lastname,
      product_type: 'NOMINA',
      benefit_code: 'NODEFINIDO',
    };

    const selectedAgreement = this.abreCuentasService.getAgreementSelected();

    if (selectedAgreement.transaction_type === 'true') {
      body.benefit_code = 'USAYNOPAGUES';
      parms.benefit_code = 'USAYNOPAGUES';
    }

    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectOccupation(body, parms)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
  maProduct(requestData: any, product: string) {
    this.creditGrayZone = this.parametersService.getSetting('creditGrayZone');
    let responsebool = false;
    try {
      const isData = requestData.product.data.map(element => {
        return {
          data: element.products.find(
            (e: { product_type: string }) => e.product_type === product,
          ),
          status: {
            phase: element.solicitation_phase,
            status: element.solicitation_status,
          },
        };
      });
      isData.forEach((element: { status: { phase: '06'; status: '05' } }) => {
        if (
          this.creditGrayZone.find(
            (elements: { phase: string; status: string }) =>
              elements.phase === element.status.phase &&
              elements.status === element.status.status,
          )
        ) {
          responsebool = true;
        }
      });
      return responsebool;
    } catch (error) {
      return responsebool;
    }
  }

  /**
   * Función asíncrona para enviar la información de ocupación
   * independiente del cliente
   *
   * *Async Function that sends independent occupation client info*
   *
   * @type {function}
   * @param {CiiuModel} occupation
   * @returns {Promise}
   */
  async sendProspectIndependentOccupation(occupation: CiiuModel): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectIndependentOccupation(occupation)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  async sendProspectIncomeForm(body): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectIncomeForm(body)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información de ocupación del cliente
   *
   * *Async Function that sends occupation client info*
   *
   * @type {function}
   * @param {string} body
   * @returns {Promise}
   */
  async sendProspectOccupationWithBody(body: any, parms: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectOccupation(body, parms)
        .then(res => {
          const response = {
            status: res.status,
            body: res.body.data,
          };
          resolve(response);
        })
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información de contacto del cliente
   *
   * *Async Function that sends contact client info*
   *
   * @type {function}
   * @param {string} contact
   * @returns {Promise}
   */
  async sendProspectOccupationUbicationInfo(
    contact: ContactModel,
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      await this.requestService
        .sendProspectContact(contact)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información del tipo de operación
   *
   * *Async Function that sends operation currency info*
   *
   * @type {function}
   * @param {string} contact
   * @returns {Promise}
   */
  async sendProspectOperationCurrency(
    operationCurrencyList: any,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectOperationCurrency(operationCurrencyList)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información del porductos moneda extranjera
   *
   * *Async Function that sends foreign currency products*
   *
   * @type {function}
   * @param {string} productInfo
   * @returns {Promise}
   */
  async sendProspectForeignCurrencyProducts(productInfo: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectForeignCurrencyProducts(productInfo)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función guardar información de la ciudad de nacimiento
   *
   * *Function that saves birthplace prospect*
   *
   * @param {any} data
   */
  async sendProspectBirthplace(city: CityModel): Promise<any> {
    return this.requestService.sendProspectBirthplace(city);
  }

  /**
   * Función guardar información de la ciudad y dirección de la oficina
   *
   * *Function that saves office address*
   *
   * @param {any} body
   */
  async sendProspectOfficeAddress(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectOfficeAddress(body)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función guardar información financiera
   *
   * *Function that saves financial info*
   *
   * @param {any} body
   */
  async sendProspectFinancial(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectFinancial(body)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Funcion que desacopla los ternarios y evita el branching en los test.
   * @param variable variable a evaluar
   * @param defaultValue valor por defecto a retornar si la variable es undefined
   */
  getValueWithOutUndefined(variable: any, defaultValue: any) {
    return variable !== undefined ? variable : defaultValue;
  }

  async getOTP(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .getOTP(body)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona que valida el codigo otp
   *
   * *Async Function that validate the otp code*
   *
   * @type {function}
   * @param {any} body
   */
  async validateOTP(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .validateOTP(body)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información de ocupación
   * independiente del cliente
   *
   * *Async Function that sends independent occupation client info*
   *
   * @type {function}
   * @param {CiiuModel} occupation
   * @returns {Promise}
   */
  async sendPostTermsAndConditions(devicePrint: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .sendProspectIndependentOccupation(devicePrint)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  buildClientBody(data: any) {
    let codePCO = '';
    let civilStatus: any;
    let socialClassType = '';
    let housingTypePersonal = '';
    let ethnicGroup: '';
    const isUserJemelii = this.abreCuentasService.getUserJemelii();
    civilStatus =
      data.marital_status_code !== undefined ? data.marital_status_code : '';
    ethnicGroup =
      data.ethnic_group_code !== undefined ? data.ethnic_group_code : '';
    socialClassType = data.address !== undefined ? data.address.stratum : '';
    housingTypePersonal =
      data.address !== undefined ? data.address.housingType.housingId : '';
    if (
      (data.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
        data.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
        data.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
        data.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) &&
      !(
        !this.firmlyApprovedService.isEmpty() &&
        this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
      )
    ) {
      codePCO = data.solicitation_status.status_code.replace('PCO', '');
    }
    let pep_questions: any;
    if (
      this.validationHelperService.isPassiveProduct() ||
      (!this.firmlyApprovedService.isEmpty() &&
        this.firmlyApprovedService.getOfferType_Channel() === 'En_firme')
    ) {
      pep_questions = {
        pep_questions: [
          {
            question_id: '1',
            answer: data.IsPEP !== undefined ? data.IsPEP.elementId === 1 : '',
            justification: 'N/A',
          },
        ],
      };
    }
    let birthdate = data.birthdate.toString();
    const birthdateArr = birthdate.split('/');
    if (birthdateArr[0].length !== 4) {
      birthdate = birthdateArr.reverse().join('-');
    }
    const body = {
      document: {
        type:
          data.product_type == BUSINESS_CONST.PRODUCT_TYPE_LIVING
            ? data.document_type
            : this.validationHelperService.filterDocumentType(
              data.document_type,
            ),
        number: data.document_number,
        date_of_issue: data.date_of_issue
          .toString()
          .split('/')
          .reverse()
          .join('-'),
      },
      given_names: [data.firstname, data.middlename || ''],
      first_surname: data.primary_lastname,
      second_surname: data.second_lastname,
      gender:
        data.isPostlogin &&
          data.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING
          ? data.sex
          : data.sex,
      education_level: null,
      birthdate,
      birth_place:
        (data.bp_province_code
          ? data.bp_province_code
          : data.province_code || '') +
        (data.bp_city_code ? data.bp_city_code : data.city_code || ''),
      nationality: 'COL',
      is_client: isUserJemelii ? false :
        data.isPostlogin &&
          data.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING
          ? data.isPostlogin
          : false,
      agreement_code: '',
      social_class: socialClassType ? socialClassType : '',
      housing_type: housingTypePersonal ? housingTypePersonal : '',
      format_required:
        data.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
        data.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
        data.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
        data.product_type === BUSINESS_CONST.MULTI,
      is_was_client: isUserJemelii ? false : this.abreCuentasService.getPostlogin(),
      manager: {
        manager_id: data.advisorCheck === '1' ? data.advisorCode : '',
      },
      marital_status: civilStatus ? civilStatus : '',
      ethnic_group: ethnicGroup ? ethnicGroup : '',
      solicitation_status: {
        status_code: codePCO,
        status_description: '',
      },
      ...pep_questions,
      branch_code:
        data.isPostlogin &&
          data.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING
          ? data.originator_branch
            .toString()
            .replace(/^(\d{1})$/g, '00$1')
            .replace(/^(\d{2})$/g, '0$1')
          : data.agency_code,
      update_client: data.updateClient,
      restrictive_status: data.list_query_status
        ? data.list_query_status.status_code
        : '',
    };
    if (
      !this.firmlyApprovedService.isEmpty() &&
      this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
    ) {
      body.role = '1';
    }
    console.warn('///** IS CLIENT ' + body.is_client + '  -- WAS_CLIENT ' + body.is_was_client);
    console.warn('Body ajustado: ', body);
    const issuedExpedition = {
      city: data.issued_city,
      department: data.issued_department,
    };
    if (
      issuedExpedition.city &&
      issuedExpedition.city !== '' &&
      issuedExpedition.department &&
      issuedExpedition.department !== ''
    ) {
      body['issued_city'] = this.validationHelperService.filterCityByNames(
        issuedExpedition.city,
        issuedExpedition.department,
      );
    }

    return body;
  }

  async createClient() {
    // tslint:disable-next-line:no-shadowed-variable
    const {
      birthplaceInfo,
      fiModel,
      agencySelected,
      // tslint:disable-next-line: no-shadowed-variable
      ContactModel,
      maritalStatusModel,
      ethnicGroupInfo,
      pcoModel,
      isPostlogin,
      basicModel,
      advisorCheck,
      updateClient,
      ProspectResponse,
      documentModel,
      advisorCode,
    } = this.abreCuentasService.getAbreCuentasModel();

    const product_type =
      this.abreCuentasService.getproductSelected().product_type;
    const data = {
      ...birthplaceInfo,
      ...fiModel,
      ...agencySelected,
      ...ContactModel,
      ...maritalStatusModel,
      ...ethnicGroupInfo,
      ...documentModel,
      product_type,
      ...pcoModel,
      ...basicModel,
      ...ProspectResponse,
      advisorCheck,
      updateClient,
      isPostlogin,
      advisorCode,
    };
    let body = this.buildClientBody(data);
    console.warn('Create Client >>>> Body: ', body);

    if (!this.validationHelperService.isPassiveProduct()) {
      body = {
        clients: [
          {
            ...body,
          },
        ],
      };
      if (
        this.abreCuentasService.getproductSelected().product_type ===
        BUSINESS_CONST.PRODUCT_TYPE_LIVING &&
        typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
        this.abreCuentasService.getSecondHeadline().has_second_headline
      ) {
        const {
          basicInfoSecondHeadlineModel,
          fiSecondHeadlineModel,
          contactSecondHeadlineModel,
          maritalStatusSecondHeadlineModel,
          ProspectResponseSecondHeadLine,
        } = this.abreCuentasService.getAbreCuentasModel();
        const name = this.validationHelperService.splitNames(
          basicInfoSecondHeadlineModel.name_second_headline,
          basicInfoSecondHeadlineModel.lastname_second_headline,
        );
        const dataSecond = {
          ...contactSecondHeadlineModel,
          ...maritalStatusSecondHeadlineModel,
          ...pcoModel,
          ...agencySelected,
          ...fiSecondHeadlineModel,
          ...ProspectResponseSecondHeadLine,
          advisorCheck,
          isPostlogin,
          advisorCode,
          product_type,
          document_type: this.validationHelperService.filterDocumentType(
            basicInfoSecondHeadlineModel.doc_type_second_headline.toString(),
          ),
          document_number:
            basicInfoSecondHeadlineModel.doc_number_second_headline,
          date_of_issue:
            basicInfoSecondHeadlineModel.expeditiondate_second_headline,
          firstname: name.firstname,
          middlename: name.middlename,
          primary_lastname: name.primary_lastname,
          second_lastname: name.second_lastname,
          birthdate: basicInfoSecondHeadlineModel.birthdate_second_headline,
          province_code: '',
          city_code: '',
          updateClient: false,
          issued_city: '',
          issued_department: '',
          gender: basicInfoSecondHeadlineModel.gender_second_headline,
          sex: basicInfoSecondHeadlineModel.gender_second_headline,
          agency_code: '',
        };
        const res = this.buildClientBody(dataSecond);
        console.warn('Create Client >>>> Body: ', res);
        body.clients.push(res);
      }
      /* updateClient = false; */
    }
    if (this.channel.getChannelId() === '159') {
      body.identification_analysis_ind =
        this.abreCuentasService.getflagGreyZone();
    }
    const solicitationId = this.abreCuentasService.getSolicitationId();
    await this.requestService
      .createClient({ data: body }, solicitationId)
      .then(() => {
        try {
          this.code = '200';
        } catch (error) {
          console.error(error);
          throw 500;
        }
      });
    return this.code;
  }

  buildAddressesBody(self: any, type_address: string) {
    return {
      type: type_address,
      street: self.address.address,
      city:
        (self.address.city.province_code || '') + self.address.city.city_code,
      district: (self.address.city.province_code || '') + '',
      country: 'COL',
      fiscal_country: 'COL',
      alternative_country: 'COL',
    };
  }

  async prospectAddresses(type?: string) {
    let self;
    const body: any = {
      data: {
        addresses: [],
      },
    };
    let res: any;
    if (
      this.abreCuentasService.getPostlogin() &&
      this.abreCuentasService.getproductSelected().product_type !==
      BUSINESS_CONST.PRODUCT_TYPE_LIVING && (!type || type == 'PARTICULAR')
    ) {
      // tslint:disable-next-line: no-shadowed-variable
      const { occupationSelected, ContactModel } =
        this.abreCuentasService.getAbreCuentasModel();
      const addressResidence = ContactModel.address;
      const addressOffice = this.abreCuentasService.getOfficeInfo(
        occupationSelected.id.toString(),
      ).address;
      if (addressResidence) {
        const residenceCity = addressResidence.city;
        (self = {
          address: {
            address: addressResidence.address ? addressResidence.address : '',
            city: {
              province_code: (residenceCity.province_code || '') + '',
              city_code: residenceCity.city_code,
            },
          },
        }),
          (res = this.buildAddressesBody(self, 'PARTICULAR'));
        body.data.addresses.push(res);
      }
      if (
        addressOffice &&
        this.abreCuentasService.getCiiuSelected().ciiu !== '090'
      ) {
        const laboralCity = addressOffice.city;
        (self = {
          address: {
            address: addressOffice.address ? addressOffice.address : '',
            city: {
              province_code: laboralCity.province_code
                ? (laboralCity.province_code || '') + ''
                : '',
              city_code: laboralCity.province_code ? laboralCity.city_code : '',
            },
          },
        }),
          (res = this.buildAddressesBody(self, 'LABORAL'));
        if (
          occupationSelected.id !== 3 &&
          occupationSelected.id !== 4 &&
          occupationSelected.id !== 5
        ) {
          body.data.addresses.push(res);
        }
      }
    } else {
      switch (type) {
        case 'PARTICULAR':
          self = this.abreCuentasService.getContactInfo();
          res = this.buildAddressesBody(self, type);
          body.data.addresses.push(res);
          break;
        case 'LABORAL':
          if (
            this.abreCuentasService.getAbreCuentasModel().occupationSelected
              .id === 5
          ) {
            break;
          }
          self = this.abreCuentasService.getOfficeInfo(
            this.abreCuentasService.getOccupationSelected().id + '',
          );
          res = this.buildAddressesBody(self, type);
          body.data.addresses.push(res);
          break;
        case 'CARD_SEND':
          self = this.abreCuentasService.getAddressInfoConfigTc();
          // const normalizedAddress = this.stringHelperService.normalizeAddress(
          //   self.address,
          //   self.detail || '',
          // );
          (self = {
            address: {
              address: self.address,
              city: {
                province_code: self.city.province_code,
                city_code: self.city.city_code,
              },
            },
          }),
            (type = 'ENTREGA_MEDIO');
          res = this.buildAddressesBody(self, type);
          body.data.addresses.push(res);
          break;
        default:
          const occupation = this.abreCuentasService.getOccupationSelected();
          const ciiu = this.abreCuentasService.getCiiuSelected();
          // tslint:disable-next-line:early-exit
          if (occupation.id === 2 && ciiu.ciiu === '090') {
            self = this.abreCuentasService.getContactInfo();
            res = this.buildAddressesBody(self, 'PARTICULAR');
            body.data.addresses.push(res);
          }

          break;
      }
    }
    if (!this.validationHelperService.isPassiveProduct()) {
      body.data = {
        clients: [
          {
            document: {
              type: this.abreCuentasService.getDocumentInfo().document_type,
              number: this.abreCuentasService.getDocumentInfo().document_number,
            },
            ...body.data,
          },
        ],
      };

      if (
        this.abreCuentasService.getproductSelected().product_type ===
        BUSINESS_CONST.PRODUCT_TYPE_LIVING &&
        typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
        typeof this.abreCuentasService.getSecondHeadline().has_second_headline
      ) {
        let bodySecondHeadline: any = {};
        const dataSecondHeadline =
          this.abreCuentasService.getContactInfoSecondHeadline();
        bodySecondHeadline = this.buildAddressesBody(
          dataSecondHeadline,
          type || '',
        );
        const secondData = {
          document: {
            type: this.abreCuentasService.getBasicInfoSecondHeadline()
              .doc_type_second_headline,
            number:
              this.abreCuentasService.getBasicInfoSecondHeadline()
                .doc_number_second_headline,
          },
          addresses: [bodySecondHeadline],
        };
        body.data.clients.push(secondData);
      }
    }
    await this.requestService
      .createCaseAddress(body, this.abreCuentasService.getSolicitationId())
      .then(() => {
        try {
          this.code = '200';
        } catch (error) {
          this.code = '500';
        }
      });
    return this.code;
  }

  buildBodyContactLaboral(data: any) {
    return {
      data: {
        emails: [
          {
            email_type: 'PARTICULAR',
            email: data.email,
          },
        ],
        phones: [
          {
            phone_type: 'LABORAL',
            phone_number: data.employment_number,
          },
        ],
        solicitation_id: this.abreCuentasService.getSolicitationId(),
      },
    };
  }

  buildBodyContactParticular(data: any) {
    return {
      data: {
        emails: [
          {
            email_type: 'PARTICULAR',
            email: data.email,
          },
        ],
        phones: [
          {
            phone_type: 'CELULAR',
            phone_number: data.mobile_number,
          },
          {
            phone_type: 'PARTICULAR',
            phone_number: data.mobile_number,
          },
        ],
        solicitation_id: this.abreCuentasService.getSolicitationId(),
      },
    };
  }

  async createContactInfo(type?: string) {
    let body: any = {};
    // tslint:disable-next-line: no-shadowed-variable
    const { isPostlogin, ContactModel, contactSecondHeadlineModel } =
      this.abreCuentasService.getAbreCuentasModel();
    type = isPostlogin ? 'PARTICULAR' : type;
    const data = ContactModel;
    switch (type) {
      case 'LABORAL':
        body = this.buildBodyContactLaboral(data);
        break;
      case 'PARTICULAR':
        body = this.buildBodyContactParticular(data);
        break;
    }

    if (
      isPostlogin &&
      data.employment_number &&
      data.employment_number !== ''
    ) {
      body.data.phones.push({
        phone_type: 'LABORAL',
        phone_number: data.employment_number,
      });
    }

    if (!this.validationHelperService.isPassiveProduct()) {
      body.data = {
        clients: [
          {
            document: {
              type: this.abreCuentasService.getDocumentInfo().document_type,
              number: this.abreCuentasService.getDocumentInfo().document_number,
            },
            ...body.data,
          },
        ],
      };

      if (
        this.abreCuentasService.getproductSelected().product_type ===
        BUSINESS_CONST.PRODUCT_TYPE_LIVING &&
        typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
        typeof this.abreCuentasService.getSecondHeadline()
          .has_incomes_second_headline !== 'undefined'
      ) {
        let bodySecondHeadline: any = {};
        const dataSecondHeadline = contactSecondHeadlineModel;
        bodySecondHeadline =
          this.buildBodyContactParticular(dataSecondHeadline);
        const secondData = {
          document: {
            type: this.abreCuentasService.getBasicInfoSecondHeadline()
              .doc_type_second_headline,
            number:
              this.abreCuentasService.getBasicInfoSecondHeadline()
                .doc_number_second_headline,
          },
          ...bodySecondHeadline.data,
        };
        body.data.clients.push(secondData);
      }
    }
    const solicitationId = this.abreCuentasService.getSolicitationId();
    await this.requestService
      .createCaseContactInfo(body, solicitationId)
      .then(() => {
        try {
          this.code = '200';
        } catch (error) {
          throw 500;
        }
      });
    return this.code;
  }

  buildFinancialBody(data: any) {
    const otherFunds = data.otherFinancialModel.otherFunds
      ? data.otherFinancialModel.otherFunds
      : null;
    const otherIncomes = data.otherFinancialModel.otherIncomes
      ? +data.otherFinancialModel.otherIncomes
      : 0;
    const product_type = data.productSelected.product_type;

    let body = {
      document: {
        type: data.document_type,
        number: data.document_number,
      },
      segment: null,
      segment_additional_info: {
        segment_id: data.isPostlogin
          ? data.customerData.basic.sub_segment_id
          : data.infoInferredIncomes.segment_id,
        // data.infoInferredIncomes.segment_id, To do
        sub_segment_id: data.isPostlogin
          ? data.customerData.basic.segment_id
          : 'AAQ',
      },
      incomes_info: {
        principal_activity: '010', // data.occupationSelected.ciiu, To do
        principal_income: {
          currency: 'COP',
          amount: data.financialModel.incomes,
          decimals: 0,
        },
        alternative_incomes_description: otherFunds,
        alternative_incomes: {
          currency: 'COP',
          amount: otherIncomes,
          decimals: 0,
        },
        source_other_incomes: data.financialModel.funds,
      },
      discounts_info: {
        additionals_discounts: {
          currency: 'COP',
          amount: data.financialModel.expensesDiscount,
          decimals: 0,
        },
      },
      monthly_outcome: {
        currency: 'COP',
        amount: data.financialModel.expenses,
        decimals: 0,
      },
      active_amount: {
        currency: 'COP',
        amount: data.financialModel.goods,
        decimals: 0,
      },
      passive_amount: {
        currency: 'COP',
        amount: data.financialModel.debt,
        decimals: 0,
      },
      agreement_code: data.agreementSelected.agreement_code,
    };

    if (this.validationHelperService.isPassiveProduct()) {
      body.incomes_info['type_incomes'] = data.infoInferredIncomes.income_type;
      body.incomes_info['alternative_source_incomes'] =
        data.infoInferredIncomes.income_amount;
      body.incomes_info['source_incomes'] =
        data.infoInferredIncomes.source_type;
    }
    if (data.occupationSelected.id === 1) {
      let hiringDate;
      let laborCompany;
      let branchCode;
      const companyName =
        data.officeModel[data.officeModel.length - 1].company_name;
      const newCompanyDate = data.employedContractModel.contractDate;
      laborCompany = companyName
        ? companyName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        : this.dataClient.financial.labor_company;
      if (
        (product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
          product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) &&
        !data.isPostlogin
      ) {
        hiringDate = newCompanyDate;
      } else {
        hiringDate = newCompanyDate
          ? newCompanyDate
          : data.customerData.financial.company_start_date.trim();
      }
      branchCode =
        (data.employedContractModel.typeContract.elementId || '') + '';
      body['branch_code'] = branchCode;
      body['labor_company'] = laborCompany;
      body['hiring_date'] =
        hiringDate !== '' ? hiringDate.split('/').reverse().join('-') : null;
    }
    if (data.occupationSelected.id === 2) {
      body = {
        ...body,
        incomes_info: {
          ...body.incomes_info,
          principal_activity: data.ciiuModel.ciiu
            ? data.ciiuModel.ciiu
            : data.customerData.basic.professional_activity.find(
              (item: { key: string; name: string }) => item.key === 'sic',
            ).name,
        },
      };

      body['hiring_date'] = data.ciiuDate.split('/').reverse().join('-');
      body['labor_company'] =
        data.officeModel[data.occupationSelected.id] &&
          data.officeModel[data.occupationSelected.id].company_name
          ? data.officeModel[data.occupationSelected.id].company_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
          : '';
    }
    return body;
  }

  async createFinancials() {
    const {
      infoInferredIncomes,
      isPostlogin,
      financialModel,
      otherFinancialModel,
      productSelected,
      occupationSelected,
      agreementSelected,
      officeModel,
      employedContractModel,
      ciiuModel,
      ciiuDate,
      customerData,
      documentModel,
    } = this.abreCuentasService.getAbreCuentasModel();
    const self = this.abreCuentasService.getAbreCuentasModel();
    this.dataClient = this.abreCuentasService.getCustomerData();
    this.financialInfo = this.abreCuentasService.getFinancialInfo();

    const data = {
      infoInferredIncomes,
      isPostlogin,
      financialModel,
      otherFinancialModel,
      productSelected,
      occupationSelected,
      agreementSelected,
      officeModel,
      employedContractModel,
      ciiuModel,
      ciiuDate,
      customerData,
      ...documentModel,
    };
    let body: any = this.buildFinancialBody(data);
    if (occupationSelected.id) {
      body.profession = occupationSelected.id;
    }

    if (!this.validationHelperService.isPassiveProduct()) {
      body = [
        {
          document: {
            type: this.abreCuentasService.getDocumentInfo().document_type,
            number: this.abreCuentasService.getDocumentInfo().document_number,
          },
          ...body,
        },
      ];
    }

    if (
      typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
      this.abreCuentasService.getSecondHeadline().has_second_headline &&
      productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING
    ) {
      const {
        basicInfoSecondHeadlineModel,
        occupationSelectedSecondHeadline,
        employedContractSecondHeadlineModel,
        financialSecondHeadlineModel,
        otherFinancialSecondHeadlineModel,
        ciiuSecondModel,
        ciiuSecondDate,
        officeSecondHeadlineModel,
      } = this.abreCuentasService.getAbreCuentasModel();
      const data2 = {
        infoInferredIncomes,
        isPostlogin,
        agreementSelected,
        occupationSelected: occupationSelectedSecondHeadline,
        financialModel: financialSecondHeadlineModel,
        otherFinancialModel: otherFinancialSecondHeadlineModel,
        officeModel: officeSecondHeadlineModel,
        employedContractModel: employedContractSecondHeadlineModel,
        productSelected,
        ciiuModel: ciiuSecondModel,
        ciiuDate: ciiuSecondDate,
        customerData,
      };

      const body2: any = this.buildFinancialBody(data2);
      if (occupationSelectedSecondHeadline.id) {
        body2.profession = occupationSelectedSecondHeadline.id;
      }

      (body2.document = {
        type: 1,
        number: basicInfoSecondHeadlineModel.doc_number_second_headline,
      }),
        body.push(body2);
    }
    await this.requestService
      .createCaseFinancials(
        { data: body },
        this.abreCuentasService.getSolicitationId(),
      )
      .then(() => {
        try {
          this.code = '200';
        } catch (error) {
          throw 500;
        }
      });
    return this.code;
  }

  /**
   * Función para evaluar un boolean y retornar un valor
   * Se usa para disminuir el branching
   * @param value Valor a evaluar
   * @param caseTrue Retorno en caso true
   * @param caseFalse Retorno en caso false
   */
  getValueByValidateBoolean(value: any, caseTrue: any, caseFalse: any) {
    return value ? caseTrue : caseFalse;
  }

  buildPerformeIncomeBody(data: any, account_holder_type: string) {
    const incomes_sum_flag =
      typeof data.secondHeadlineModel === 'undefined'
        ? false
        : data.secondHeadlineModel.has_incomes_second_headline;
    data.document_type =
      data.product_type == BUSINESS_CONST.PRODUCT_TYPE_LIVING
        ? data.document_type
        : this.validationHelperService.filterDocumentType(data.document_type);
    let segment_additional_info;
    if (data.isPostlogin) {
      segment_additional_info = {
        segment_additional_info: {
          segment_id: data.basicModel.sub_segment_id,
          sub_segment_id: data.basicModel.segment_id,
        },
      };
    }
    console.warn('data recibida: ', data);
    const dataBirthDate = data.birthdate ? data.birthdate : data.date_of_issue;
    const formatBirthdate = this.formatBirthDate(dataBirthDate);
    return {
      document: {
        type: data.document_type,
        number: data.document_number,
      },
      incomes_sum_flag,
      first_name: data.firstname,
      first_surname: data.primary_lastname,
      second_name: data.middlename,
      second_surname: data.second_lastname,
      birthdate: formatBirthdate + 'T',
      account_holder_type,
      ...segment_additional_info,
    };
  }

  /**
   * Función para realizar el llamado de terceras fuentes desde bizagi
   *
   * *Function to call incomes since bizagi*
   *
   * @type {function}
   * @returns {this.code}
   */
  async performIncomes() {
    const isUserJemelii = this.abreCuentasService.getUserJemelii();
    const { documentModel, isPostlogin, basicModel, productSelected } =
      this.abreCuentasService.getAbreCuentasModel();
    let account_holder_type = '01';
    const data = this.buildPerformeIncomeBody(
      { ...documentModel, isPostlogin, basicModel, ...productSelected },
      account_holder_type,
    );
    data.is_client = isUserJemelii ? false : isPostlogin;
    console.log('///** PERFORME INCONMES IS_CLIENT ' + data.is_client);
    const firmlyApproved =
      !this.firmlyApprovedService.isEmpty() &&
        this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
        ? true
        : false;
    const body: any = {
      solicitation_type: 'tskConsultarWaiver',
      offer_approved_ind: firmlyApproved,
      clients: [
        {
          ...data,
        },
      ],
    };

    if (
      typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
      this.abreCuentasService.getSecondHeadline().has_incomes_second_headline &&
      this.abreCuentasService.getSecondHeadline().has_second_headline
    ) {
      const { basicInfoSecondHeadlineModel, secondHeadlineModel } =
        this.abreCuentasService.getAbreCuentasModel();
      const mapNames = this.validationHelperService.splitNames(
        basicInfoSecondHeadlineModel.name_second_headline,
        basicInfoSecondHeadlineModel.lastname_second_headline,
      );
      const mapbody = {
        document_type: basicInfoSecondHeadlineModel.doc_type_second_headline,
        document_number:
          basicInfoSecondHeadlineModel.doc_number_second_headline,
        firstname: mapNames.firstname,
        primary_lastname: mapNames.primary_lastname,
        middlename: mapNames.middlename,
        second_lastname: mapNames.second_lastname,
        birthdate: basicInfoSecondHeadlineModel.birthdate_second_headline,
        secondHeadlineModel,
      };
      account_holder_type = '02';
      const dataSecondHeadLine = this.buildPerformeIncomeBody(
        mapbody,
        account_holder_type,
      );
      body.clients.push(dataSecondHeadLine);
    }
    if (this.channel.getChannelId() === '163') {
      // body.offer_approved_inf = true,

      body.partner = {
        document: {
          number: this.abreCuentasService.getRateAlly().partner.document.number,
        },
      };
    }
    await this.requestService
      .performIncomes(
        { data: body },
        this.abreCuentasService.getSolicitationId(),
      )
      .then(result => {
        this.code = result.status.toString();
      });
    return this.code;
  }

  /**
   * Función que obtiene el resultado de pco
   *
   * *Function get pco result*
   *
   */
  async getResultPco(): Promise<any> {
    const productSelected = this.abreCuentasService.getproductSelected();
    const productType = productSelected ? productSelected.product_type : '';
    const data = this.abreCuentasService.getAbreCuentasModel();
    let date;
    let laborDate = {};
    let employment_type;
    let codCity = '';
    let is_pep_client = '';
    let sicCode = '';
    let civil_status = 0;
    let stratum = '';
    let homeType = '';
    let genderPerson = '';
    switch (data.occupationSelected.id) {
      case 1:
        date = data.employedContractModel.contractDate || '';
        employment_type =
          data.employedContractModel.typeContract.elementId + '';
        break;
      case 2:
        date = data.ciiuDate || '';
        employment_type = '';
        break;
      default:
        break;
    }
    if (date) {
      const dateOcupation = date.split('/');
      const actualDate = new Date();
      const resultDate =
        +actualDate.getMonth() +
        actualDate.getFullYear() * 12 -
        (+dateOcupation[1] + +dateOcupation[2] * 12);
      laborDate = {
        labor_seniority: [
          {
            count: Math.floor(resultDate / 12) + '',
            unit_type: 'Years',
          },
          {
            count: (resultDate % 12) + '',
            unit_type: 'Months',
          },
        ],
      };
    }
    if (
      productType === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      productType === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      productType === BUSINESS_CONST.PRODUCT_TYPE_TC
    ) {
      codCity =
        data.ContactModel.address.city.province_code +
        '-' +
        data.ContactModel.address.city.city_code;
      is_pep_client = data.fiModel['IsPEP'].value === 'no' ? '0' : '1';
      sicCode = data.occupationSelected.ciiu;
      civil_status =
        data.maritalStatusModel.marital_status_code !== undefined
          ? data.maritalStatusModel.marital_status_code
          : 0;
      stratum =
        data.ContactModel.address.stratum !== undefined
          ? data.ContactModel.address.stratum
          : '';
      homeType =
        data.ContactModel.address.housingType !== undefined
          ? data.ContactModel.address.housingType.housingId
          : '';
      genderPerson = this.abreCuentasService.getPostlogin()
        ? this.abreCuentasService.getBasicInfo().gender
        : data.documentModel.sex;
    }
    const taxInfo =
      this.abreCuentasService.getinfoInferredIncomes().segmentation_id === 335
        ? 'sucursal'
        : 'PB';
    const body = {
      document: {
        number: data.documentModel.document_number,
        type: 'CC',
      },
      first_name: data.documentModel.firstname,
      second_name: data.documentModel.middlename
        ? data.documentModel.middlename
        : '',
      first_surname: data.documentModel.primary_lastname,
      second_surname: data.documentModel.second_lastname,
      birthdate: data.documentModel.birthdate.replace(/\//g, '-'),
      phone: data.ContactModel.mobile_number,
      employment_type,
      principal_activity_id: data.occupationSelected.id + '',
      is_client_flag: !this.abreCuentasService.getProspectResponse().client,
      income_source: data.infoInferredIncomes.source_type,
      income_amount: [
        {
          amount: {
            currency: 'COP',
            amount: data.infoInferredIncomes.income_amount.amount,
            decimals: 0,
          },
          type: data.infoInferredIncomes.income_type,
        },
        {
          amount: {
            currency: 'COP',
            amount: data.financialModel.incomes,
            decimals: 0,
          },
          type: 'Fixed',
        },
        {
          amount: {
            currency: 'COP',
            amount:
              data.otherFinancialModel.otherIncomes !== undefined
                ? data.otherFinancialModel.otherIncomes
                : 0,
            decimals: 0,
          },
          type: 'Other',
        },
      ],
      ...laborDate,
      solicitation_product: [
        {
          product_type: productSelected.product_code,
          priority: '1',
          limit_amount: {
            currency: 'COP',
            decimals: 2,
          },
          period: '90',
          hood_type: 0,
        },
      ],
      pep_cliente: is_pep_client,
      sic_code: sicCode,
      marital_status: civil_status.toString(),
      social_class: stratum.toString(),
      home_type: homeType.toString(),
      gender: genderPerson,
      city: codCity,
    };
    const solicitation = body.solicitation_product[0];
    if (productType === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
      solicitation.limit_amount['amount'] = data.creditParms.maxAmountValue;
      const val = this.helperService.getRateBySegment(
        data.creditParms.rateValue,
        data.infoInferredIncomes.segment_id,
        'NMV',
        RISK_LEVELS.NORISK,
      );
      (solicitation['rate'] = parseFloat(
        val.replace(',', '.').replace('%', ''),
      )),
        (solicitation['term'] = data.creditParms.maxPeriodValue);
    } else {
      solicitation.limit_amount['amount'] = 500000000;
    }

    return new Promise((resolve, reject) => {
      this.requestService
        .getResultPco({ data: body })
        .then(res => {
          if (res.status === 200) {
            this.abreCuentasService.setPcoModel(res.body.data);
            return resolve(res.body.data);
          }
        })
        .catch(err => reject(err));
    });
  }

  buildPerformPcoBody(data: any, role: string) {
    let typeProductsSelected: any[];
    if (data.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      typeProductsSelected = [
        {
          product_type: data.product_type,
          prioritizeForClient: '1',
          product_code: data.product_code,
        },
      ];
    } else if (data.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      typeProductsSelected = [
        {
          product_type: data.product_type,
          prioritizeForClient: '1',
          product_code: data.product_code,
        },
      ];
    } else {
      typeProductsSelected = this.abreCuentasService
        .getProductsSelects()
        .map(dataResponse => {
          return {
            product_type: dataResponse.product_type,
            product_code: dataResponse.product_code,
            prioritizeForClient: dataResponse.prioritizeForClient,
          };
        });
    }
    let date;
    let contract_type: any = null;
    let years;
    let months;
    let duration_list = {};
    const prospect = this.abreCuentasService.getProspectResponse();
    const incomes_sum_flag =
      typeof data.secondHeadlineModel === 'undefined'
        ? false
        : data.secondHeadlineModel.has_incomes_second_headline;

    let products: any[] = [];

    typeProductsSelected.forEach(dataObjProduct => {
      if (dataObjProduct.product_type === BUSINESS_CONST.MULTI) {
        return;
      }
      let dataProduct = {};

      if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
        dataProduct = {
          product_type:
            dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING
              ? this.abreCuentasService.getOtherSimulationData().sub_product
              : dataObjProduct.product_code,
          product_subtype:
            this.abreCuentasService.getOtherSimulationData().code,
        };
      } else if (
        dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
      ) {
        dataProduct = {
          product_type: dataObjProduct.product_code,
        };
      } else if (
        dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE
      ) {
        dataProduct = {
          product_type: dataObjProduct.product_code,
          product_subtype: '533',
        };
      } else if (
        dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN
      ) {
        dataProduct = {
          product_type: dataObjProduct.product_code,
          product_subtype: '371',
          product_destination_type: this.abreCuentasService.getProductDestinationType(),
        };
      } else {
        dataProduct = {
          product_type: dataObjProduct.product_code,
          product_subtype:
            prospect.client === false
              ? '131'
              : this.helperService.getProductCodeBySegmentId(
                data.sub_segment_id,
              ),
        };
      }
      let allInfoProduct = {
        product: dataProduct,
        priority: dataObjProduct.prioritizeForClient,
      };
      if (
        dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
        dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
        dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN
      ) {
        const aditionalData = {
          installments_quantity:
            this.abreCuentasService.getAbreCuentasModel().creditParms
              .maxPeriodValue,
          term: {
            frecuency: 'MM',
          },
          available_amount: {
            amount:
              this.abreCuentasService.getAbreCuentasModel().creditParms
                .maxAmountValue,
            decimals: 0,
            currency: 'COP',
          },
        };
        allInfoProduct = Object.assign(allInfoProduct, aditionalData);
      }
      if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
        const { simulatorModel } =
          this.abreCuentasService.getAbreCuentasModel();
        if (
          simulatorModel.product_subline === '03' ||
          simulatorModel.product_subline === '55'
        ) {
          const liabilities = [
            {
              liability_id: simulatorModel.libialities.liability_id,
              bank_id: simulatorModel.libialities.liability_id,
              bank_name: simulatorModel.libialities.bank_name,
              payoff_amount: {
                currency: simulatorModel.available_amount.currency,
                amount: simulatorModel.available_amount.amount,
                decimals: simulatorModel.available_amount.decimals,
              },
            },
          ];
          const objectLiving = { liabilities, fee_amount: simulatorModel.fee };
          allInfoProduct = Object.assign(allInfoProduct, objectLiving);
        }
        const data_living = {
          assisted_housing_flag: simulatorModel.assisted_housing_flag,
          new_housing_flag: simulatorModel.new_housing_flag,
          financing_type: simulatorModel.financing_type,
          purchase_option: simulatorModel.purchase_option,
          own_project_flag: simulatorModel.own_project_flag,
          capital_amount: simulatorModel.property_amount,
        };
        allInfoProduct = Object.assign(allInfoProduct, data_living);
      }
      if (this.abreCuentasService.getFlowLoan() && dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
        const destinity = {
          destinity: this.abreCuentasService.getRequestLoanSelected().elementId,
        };
        allInfoProduct = Object.assign(allInfoProduct, destinity);
        const getCreditSelection = this.abreCuentasService.getCreditList();
        if (getCreditSelection) {
          getCreditSelection.map((value: any) => {
            this.credit_recharge_up_information.push({
              credit_recharge_up_id: value.number,
              account_subtype: value.type,
              payoff_amount: {
                currency: BANK_INFO_CONST.CURRENCY,
                amount: value.amount,
                decimals: 0,
              },
              monthly_fee_amount: {
                currency: BANK_INFO_CONST.CURRENCY,
                amount: '',
                decimals: 0,
              },
            });
          });
          const recharge = { credit_recharge_up_information: this.credit_recharge_up_information };
          allInfoProduct = Object.assign(allInfoProduct, recharge);
        }
        const fee_amount = {
          fee_amount: {
            currency: 'COP',
            amount: this.abreCuentasService.getSaveValueInputAmount()
              ? this.abreCuentasService.getSaveValueInputAmount()
              : '0',
            decimals: 0,
          },
        };
        allInfoProduct = Object.assign(allInfoProduct, fee_amount);
      }
      products.push(allInfoProduct);
    });

    if (data.typeContract.elementId) {
      switch (data.id) {
        case 1:
          date = data.contractDate || '';
          contract_type = data.typeContract.elementId + '';
          break;
        case 2:
          date = data.ciiuDate || '';
          contract_type = '';
          break;
        default:
          break;
      }
    }
    if (date) {
      const dateOcupation = date.split('/');
      const actualDate = new Date();
      let resultDate =
        +actualDate.getMonth() +
        actualDate.getFullYear() * 12 -
        (+dateOcupation[1] + +dateOcupation[2] * 12);
      if (
        +actualDate.getMonth() + 1 === +dateOcupation[1] &&
        +actualDate.getDate() >= +dateOcupation[0]
      ) {
        resultDate += 1;
      }
      years = Math.floor(resultDate / 12) + '';
      months = (resultDate % 12) + '';
      duration_list = {
        duration: [
          {
            count: years,
            unit: 'Years',
          },
          {
            count: months,
            unit: 'Months',
          },
        ],
      };
    }

    const clients: any = {
      document: {
        number: data.document_number,
        type: data.document_type,
      },
      gender: data.isPostlogin ? data.gender : data.sex,
      social_class: data.address.stratum.toString(),
      housing_type: data.address.housingType.housingId.toString(),
      marital_status: data.marital_status_code.toString(),
      role,
      // profession: data.id.toString(),
      profession: data.id ? data.id.toString() : '2',
      incomes_info: {
        principal_activity: data.ciiu,
        contract_type,
        incomes_sum_flag,
        principal_income: {
          currency: 'COP',
          amount: data.incomes,
          decimals: 0,
        },
        alternative_incomes: {
          currency: 'COP',
          amount: data.otherIncomes !== undefined ? data.otherIncomes : 0,
          decimals: 0,
        },
      },
      duration_list: {
        ...duration_list,
      },
      pep_questions: [
        {
          question_id: '1',
          answer: data.IsPEP !== undefined ? data.IsPEP.elementId === 1 : false,
          justification: 'NA',
        },
      ],
    };
    return { clients, products };
  }

  /**
   * Función para llamar los servicios de pco desde bizagi
   *
   * *Function to call pco since bizagi*
   *
   * @type {function}
   * @returns {this.code}
   */
  async performPco() {
    // tslint:disable-next-line: no-shadowed-variable
    const {
      documentModel,
      financialModel,
      otherFinancialModel,
      employedContractModel,
      // tslint:disable-next-line: no-shadowed-variable
      ContactModel,
      productSelected,
      occupationSelected,
      secondHeadlineModel,
      otherSimulationData,
      ciiuModel,
      fiModel,
      basicModel,
      maritalStatusModel,
      creditParms,
      infoInferredIncomes,
      ciiuDate,
      isPostlogin,
    } = this.abreCuentasService.getAbreCuentasModel();
    const models = {
      ...documentModel,
      ...financialModel,
      ...otherFinancialModel,
      ...employedContractModel,
      ...productSelected,
      ...occupationSelected,
      otherSimulationData,
      ...maritalStatusModel,
      ...basicModel,
      ...fiModel,
      ...ContactModel,
      creditParms,
      ...infoInferredIncomes,
      ciiuModel,
      ciiuDate,
      secondHeadlineModel,
      isPostlogin,
    };
    let role = '1';
    const { clients, products } = await this.buildPerformPcoBody(models, role);

    // clients.incomes_info.contract_type = '2';

    const refund_information = this.abreCuentasService.getDisbursementInfo();
    const body: any = {
      solicitation_type: 'tskConsPCOViabilidad',
      channel_code: '01',
      clients: [
        {
          ...clients,
        },
      ],
      products,
      refund_information,
      agreement: {
        agreement_code:
          this.abreCuentasService.getAgreementSelected().agreement_number,
        agreement_group: '',
        agreement_rate_type: '',
        agreement_sector: '',
        agreement_status: '',
      },
    };

    if (
      typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
      this.abreCuentasService.getSecondHeadline().has_second_headline &&
      this.abreCuentasService.getSecondHeadline().has_incomes_second_headline
    ) {
      const {
        contactSecondHeadlineModel,
        basicInfoSecondHeadlineModel,
        occupationSelectedSecondHeadline,
        employedContractSecondHeadlineModel,
        financialSecondHeadlineModel,
        otherFinancialSecondHeadlineModel,
        fiSecondHeadlineModel,
        maritalStatusSecondHeadlineModel,
        ciiuSecondModel,
        ciiuSecondDate,
      } = this.abreCuentasService.getAbreCuentasModel();
      const mapNames = this.validationHelperService.splitNames(
        basicInfoSecondHeadlineModel.name_second_headline,
        basicInfoSecondHeadlineModel.lastname_second_headline,
      );
      const mapbody = {
        document_type: this.validationHelperService.filterDocumentType(
          String(basicInfoSecondHeadlineModel.doc_type_second_headline),
        ),
        document_number:
          basicInfoSecondHeadlineModel.doc_number_second_headline,
        firstname: mapNames.firstname,
        primary_lastname: mapNames.primary_lastname,
        middlename: mapNames.middlename,
        second_lastname: mapNames.second_lastname,
        ...occupationSelectedSecondHeadline,
        ...employedContractSecondHeadlineModel,
        ...financialSecondHeadlineModel,
        ...otherFinancialSecondHeadlineModel,
        ...fiSecondHeadlineModel,
        ciiuSecondModel,
        ...contactSecondHeadlineModel,
        birthdate: basicInfoSecondHeadlineModel.birthdate_second_headline,
        ...productSelected,
        secondHeadlineModel,
        otherSimulationData,
        ...maritalStatusSecondHeadlineModel,
        creditParms,
        gender: basicInfoSecondHeadlineModel.gender_second_headline,
        sex: basicInfoSecondHeadlineModel.gender_second_headline,
        ciiu: ciiuSecondModel.ciiu,
        ciiuDate: ciiuSecondDate,
      };
      role = '17';
      const data = this.buildPerformPcoBody(mapbody, role);
      body.clients.push(data.clients);
    }
    if (this.channel.getChannelId() === CHANNEL.PORTALALLIES.CODE) {
      body.products[0].rates = this.abreCuentasService.getRateAlly().rates;
      body.channel_code = '04';
    }
    console.warn('Consumiendo PerformPCO >>>> Data: ', body);
    await this.requestService
      .performPco({ data: body }, this.abreCuentasService.getSolicitationId())
      .then(result => {
        this.code = result.status.toString();
      });
    return this.code;
  }
  /**
   * Función para llamar los servicios de pco desde canal
   *
   * *Function to call pco since bizagi*
   *
   * @type {function}
   * @returns {this.code}
   */
  async getChannelComunicator(isAlta?: boolean, phase?: boolean) {
    const { productSelected } = this.abreCuentasService.getAbreCuentasModel();
    const poroductsSelectedMulti = this.abreCuentasService.getProductsSelects();
    const solicitationId = this.abreCuentasService.getSolicitationId();
    await this.requestService
      .getChannelNotification(solicitationId)
      .then((res: any) => {
        console.log(res);
        const dataPCO = JSON.parse(this.cipherService.decrypt(res.data.message)).data[0];
        const solPhase = {
          '01': 'PCO',
          '02': 'ZGCRE',
          '03': 'VALDOC',
          '04': 'ANACRE',
          '05': 'GESSEG',
          '06': 'FORMAL',
          '07': 'ZGCUM',
          '08': 'DDA',
          '09': 'VALDOCDDA',
          '10': 'ALTA',
          '11': 'FIN',
          '12': 'SARLAFT',
          '13': 'TASAS',
          '14': 'ALTACLIENTE',
          '15': 'ALTAPROD',
          '16': 'ESC',
          '20': 'FRAUDE',
          '17': 'NORMALIZACION',
        };

        dataPCO.solicitation_phase = solPhase[dataPCO.solicitation_phase];
        if (isAlta) {
          if (dataPCO.solicitation_phase === 'PCO') {
            this.code = '127';
            return;
          }
          if (dataPCO.solicitation_phase === 'FRAUDE') {
            if (['14'].includes(dataPCO.solicitation_status)) {
              this.code = '208';
              this.abreCuentasService.getAbreCuentasModel().pcoModel.solicitation_status.status_code =
                '';
            } else if (['04'].includes(dataPCO.solicitation_status)) {
              this.code = '20-14';
            } else {
              this.code = '200';
            }
            return this.code;
          }
          if (dataPCO.solicitation_phase === 'GESSEG') {
            if (['05', '05'].includes(dataPCO.solicitation_status)) {
              this.code = '201';
              return;
            }
          }
          if (
            !this.validationHelperService.isPassiveProduct() &&
            this.firmlyApprovedService.isEmpty()
          ) {
            const status_code =
              this.abreCuentasService.getPcoModel().solicitation_status
                .status_code;
            if (status_code === 'PCO01' || status_code === 'PCO03') {
              const solHistory = dataPCO.solicitation_status_history.split(',');
              const mapHistory =
                status_code === 'PCO01'
                  ? ['10', '15', '14', '08', '07', '12']
                  : ['02', '08', '07', '12'];
              let hasValueHistory = false;
              for (const mepEl of mapHistory) {
                if (hasValueHistory) {
                  break;
                }
                for (const solEl of solHistory) {
                  if (!solEl.startsWith(mepEl)) {
                    continue;
                  }
                  dataPCO.solicitation_phase = solPhase[mepEl];
                  hasValueHistory = true;
                  break;
                }
              }
              if (!hasValueHistory) {
                this.code = '127';
                return;
              }
            }
          }
        }

        let dataGrantedProduct: any = [];
        let dataGrantedProductMulti: any = [];
        switch (dataPCO.solicitation_phase) {
          case 'PCO':
            dataPCO.products.map(dataProduct => {
              if (this.abreCuentasService.viewOptionMultiProduct) {
                const dataSelectedProduc = poroductsSelectedMulti.find(
                  data => data.product_code === dataProduct.product_type,
                );
                const dataGrantedModel = this.createObjModelPco(
                  dataSelectedProduc,
                  dataProduct,
                );
                dataGrantedProductMulti.push(dataGrantedModel);
              } else {
                dataGrantedProduct = this.createObjModelPco(
                  productSelected,
                  dataProduct,
                );
              }
            });
            const limit_tc = dataPCO.products.find(
              product => product.product_type === 'TCR',
            );
            const resultpc: PcoModel = {
              limit_amount: limit_tc ? limit_tc.available_amount.amount : 0,
              granted_product: dataGrantedProduct,
              granted_product_multi: dataGrantedProductMulti,
              solicitation_id: solicitationId,
              solicitation_status: {
                status_code:
                  dataPCO.solicitation_phase + dataPCO.solicitation_status,
                status_description: '',
              },
            };
            dataPCO.prospects.map(head => {
              if (head.role === '1') {
                this.dataIncome = this.validationHelperService.setIncomes(
                  head.income,
                );
              }
            });

            this.abreCuentasService.setinfoInferredIncomes(this.dataIncome);
            this.abreCuentasService.setPcoModel(resultpc);

            const solRates = {
              TasaEA: 'E.A.',
              TasaNMV: 'M.V.',
            };
            const dataProductValidation = poroductsSelectedMulti.filter(
              product =>
                product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE,
            );
            if (
              productSelected.product_type ===
              BUSINESS_CONST.PRODUCT_TYPE_FREE ||
              productSelected.product_type ===
              BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
              dataProductValidation.length > 0
            ) {
              this.requestService.setRates([
                {
                  value: dataPCO.credit_analisys[0].name,
                  type: solRates[dataPCO.credit_analisys[0].key],
                },
                {
                  value: dataPCO.credit_analisys[1].name,
                  type: solRates[dataPCO.credit_analisys[1].key],
                },
              ]);
              let rate: string = dataPCO.credit_analisys[0].name;
              if (rate.split('.')[1] == undefined) {
                rate = rate + '.00';
              }
              this.abreCuentasService.setRatesOffer({
                value: rate.replace(/[.,%]/g, ''),
                decimals: rate.split('.')[1].length,
              });
            }
            switch (resultpc.solicitation_status.status_code) {
              case 'PCO01':
                this.code = '200';
                if (
                  CHANNEL.PORTALO.CODE ===
                  this.channelCommunicatorService.getChannelId() &&
                  this.code === '200'
                ) {
                  if (this.abreCuentasService.getflagGreyZone()) {
                    // si es verdadero se salto evidente master
                    this.saveBitacora('id_no_PCO_A_cotinuezg');
                  } else {
                    // no se salto evidente
                    this.saveBitacora('id_ok_PCO_A_continueok');
                  }
                } else if (
                  CHANNEL.PORTALPN.CODE ===
                  this.channelCommunicatorService.getChannelId()
                ) {
                  this.code = '200';
                }
                break;
              case 'PCO02':
                this.code = '121';
                if (
                  CHANNEL.PORTALO.CODE ===
                  this.channelCommunicatorService.getChannelId() &&
                  this.code === '121'
                ) {
                  if (this.abreCuentasService.getflagGreyZone()) {
                    // si es verdadero se salto evidente master
                    this.saveBitacora('id_no_PCO_R_rechazado');
                  } else {
                    // no se salto evidente
                    this.saveBitacora('id_ok_PCO_R_rechazado');
                  }
                } else if (
                  CHANNEL.PORTALPN.CODE ===
                  this.channelCommunicatorService.getChannelId()
                ) {
                  this.code = '121';
                }
                break;
              case 'PCO03':
                this.code = '202';
                if (
                  CHANNEL.PORTALO.CODE ===
                  this.channelCommunicatorService.getChannelId() &&
                  this.code === '202'
                ) {
                  if (this.abreCuentasService.getflagGreyZone()) {
                    // si es verdadero se salto evidente master
                    this.saveBitacora('id_no_PCO_zg_cotinuezg');
                  } else {
                    // no se salto evidente
                    this.saveBitacora('id_ok_PCO_zg_continuezg');
                  }
                } else if (
                  CHANNEL.PORTALPN.CODE ===
                  this.channelCommunicatorService.getChannelId()
                ) {
                  this.code = '202';
                }

                break;
              case 'PCO04':
                this.code = '107';
                this.abreCuentasService.setIsErrorPco(true);
                break;
              default:
                this.code = '107';
                break;
            }
            break;
          case 'ALTA':
            this.isCardDuality = this.abreCuentasService.getCarduality();
            const dataArray = dataPCO.products;
            if (
              productSelected.product_type !== BUSINESS_CONST.MULTI &&
              !this.isCardDuality
            ) {
              dataArray.map(product => {
                if (
                  product.product_type === 'AHO' ||
                  product.product_type === 'NOM'
                ) {
                  const productDetail = new DetailAccountModel();
                  productDetail.account_number = product.product_id;
                  productDetail.create_date_account = dataPCO.last_update_date;
                  productDetail.account_type = product.product_type;
                  this.abreCuentasService.setDetailAccountCreation(
                    productDetail,
                  );
                }

                // TODO: VALIDAR PRODUCTOS MULTI
                if (product.product_type === 'TCR') {
                  const card: ProductCard = {
                    solicitation_id: solicitationId,
                    solicitation_type: dataPCO.solicitation_type,
                    solicitation_status: {
                      status_code: '00',
                      status_description: 'EXITOSO',
                      progress_percentage: 0,
                      error_code: '',
                      error_description: '',
                    },
                    product_id: product.product_id,
                    product_type: product.product_type,
                    client_name: dataPCO.prospects.full_name,
                    available_amount: {
                      currency: product.available_amount.currency,
                      amount: product.available_amount.amount,
                      decimals: product.available_amount.decimals,
                    },
                    expiration_date: product.expiration_date,
                  };
                  this.abreCuentasService.setProductCard(card);
                }
                if (
                  product.product_type === 'ORD' ||
                  product.product_type === 'CRP'
                ) {
                  const detailRevolvingCredit =
                    new DetailRevolvingCreditModel();
                  detailRevolvingCredit.available_amount =
                    product.available_amount.amount;
                  detailRevolvingCredit.product_id = product.product_id;
                  this.abreCuentasService.setDetailRevolvingCreditCreation(
                    detailRevolvingCredit,
                  );
                }
              });
              this.code = '200';
            } else {
              if (
                productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
              ) {
                this.code = '202';
              } else {
                this.code = '200';
              }
              const data_alta_pco = this.abreCuentasService.getPcoModel();
              data_alta_pco.granted_product_multi = dataPCO.products;
              this.abreCuentasService.setPcoModel(data_alta_pco);
            }
            break;
          case 'ZGCRE':
            this.code = '201';
            break;
          case 'ZGCUM':
            this.code = '130';
            break;
          case 'SARLAFT':
            this.code = '107';
            break;
          case 'ALTACLIENTE':
            this.code = this.validationHelperService.isPassiveProduct()
              ? '124'
              : '125';
            break;
          case 'ALTAPROD':
            this.code = this.validationHelperService.isPassiveProduct()
              ? '124'
              : '125';
            break;
          case 'TASAS':
            this.code = '107';
            break;
          case 'ESC':
            phase
              ? (this.code = '107')
              : (this.code =
                dataPCO.solicitation_status === '12' ? '200' : '129');
            break;
          case 'NORMALIZACION':
            this.code = '17';
            this.abreCuentasService.setIsNormalizacion(true);
            break;
          default:
            this.code = '127';
            break;
        }
      })
      .catch(() => (this.code = '107'));
    return this.code;
  }

  createObjModelPco(productSelected, dataProduct) {
    return {
      product_type: productSelected.product_type,
      limit_amount: {
        currency: dataProduct.available_amount.currency,
        amount: dataProduct.available_amount.amount,
        decimals: dataProduct.available_amount.decimals,
      },
    };
  }

  /**
   * Función para obtener los datos de una solicitud
   *
   * *Function to call pco since bizagi*
   *
   * @type {function}
   * @returns {this.code}
   */
  async getInfoBySolicitationId(solicitation_id: string) {
    let dataPCO = [];
    await this.requestService
      .getChannelNotification(solicitation_id)
      .then((res: any) => {
        dataPCO = JSON.parse(this.cipherService.decrypt(res.data.message)).data[0];
        this.abreCuentasService.setSolicitationInfo(dataPCO);
      })
      .catch(() => (dataPCO = []));
    return dataPCO;
  }
  /*
   * Función para solicitar las solicitudes
   * @param code
   * @returns
   */
  async getRequestByNumber(code: number, document: string) {
    const requestNumber = code.toString();
    const resObject: any = {};
    await this.requestService
      .getChannelNotification(requestNumber)
      .then((res: any) => {
        const dataRequest = JSON.parse(this.cipherService.decrypt(res.data.message)).data[0];
        if (!dataRequest) {
          resObject.code = '100';
          return resObject;
        }

        let docRes;
        if (dataRequest.prospects[0]) {
          resObject.user = dataRequest.prospects[0];
          docRes = `${resObject.user.document.number}_${resObject.user.document.type}`;
        }

        if (document !== docRes) {
          resObject.code = '100';
          return resObject;
        }

        if (!dataRequest.solicitation_date_history) {
          resObject.code = '142';
          return resObject;
        }
        // dataRequest.solicitation_status_history = '02-05,03-06,03-07,04-09,10-10';
        const creditGrayZone = [
          '02-05',
          '03-06',
          '03-07',
          '03-08',
          '04-05',
          '04-09',
          '05-05',
          '06-05',
        ];
        const refused = [
          '03-02',
          '03-08',
          '04-02',
          '04-08',
          '07-02',
          '07-08',
          '12-02',
          '12-08',
        ];
        const complianceGrayZone = ['07-05', '08-06', '09-05'];
        const isRefused = dataRequest.solicitation_status_history
          .split(',')
          .some(element => refused.indexOf(element) >= 0);
        const isInCreditGrayZone = dataRequest.solicitation_status_history
          .split(',')
          .some(element => creditGrayZone.indexOf(element) >= 0);
        const isInComplianceGrayZone = dataRequest.solicitation_status_history
          .split(',')
          .some(element => complianceGrayZone.indexOf(element) >= 0);

        if (!isInCreditGrayZone && !isInComplianceGrayZone) {
          resObject.code = '100';
          return resObject;
        }

        const oneMonthAgo = new Date();
        if (oneMonthAgo.getMonth() === 0) {
          oneMonthAgo.setFullYear(oneMonthAgo.getFullYear() - 1);
          oneMonthAgo.setMonth(11);
        } else {
          oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        }
        const dateRequest = new Date(
          dataRequest.solicitation_date_history.split(',')[0],
        );
        if (dateRequest < oneMonthAgo) {
          resObject.code = '132';
          return resObject;
        }

        this.abreCuentasService.setRequestModel(dataRequest);
        resObject.isRefused = isRefused;
        resObject.code = '200';
      })
      .catch(error => {
        console.error(error);
        resObject.code = '131';
      });
    return resObject;
  }

  async getRequestsByClient(documentId?: string) {
    // return requests[documentId] ? requests[documentId] : [];
    const resObject: any = {};
    const product_type =
      this.abreCuentasService.getproductSelected().product_type;
    await this.requestService
      .getChannelNotificationClient(
        documentId,
        product_type === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT,
      )
      .then((res: any) => {
        resObject.product = res;
        const dataRequest = res.data;
        const visibleSolicitations: any[] = [];
        dataRequest.forEach(solicitation => {
          // dataRequest.solicitation_status_history = '02-05,03-06,03-07,04-09,10-10';
          const creditGrayZone = [
            '02-05',
            '03-06',
            '03-07',
            '03-08',
            '04-05',
            '04-09',
            '05-05',
            '06-05',
          ];
          const complianceGrayZone = ['07-05', '08-06', '09-05'];
          const isInCreditGrayZone = solicitation.solicitation_status_history
            .split(',')
            .some(element => creditGrayZone.indexOf(element) >= 0);
          const isInComplianceGrayZone =
            solicitation.solicitation_status_history
              .split(',')
              .some(element => complianceGrayZone.indexOf(element) >= 0);

          // solicitation.solicitation_date_history = '2022-01-18T10:14:04';
          /* istanbul ignore if */
          const oneMonthAgo = new Date();
          if (oneMonthAgo.getMonth() === 0) {
            oneMonthAgo.setFullYear(oneMonthAgo.getFullYear() - 1);
            oneMonthAgo.setMonth(11);
          } else {
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
          }

          let dateRequest = new Date();

          if (!solicitation.solicitation_date_history) {
            dateRequest = new Date('2000-01-01T00:00:00.000');
          } else {
            dateRequest = new Date(
              solicitation.solicitation_date_history.split(',')[0],
            );
          }

          if (
            (isInCreditGrayZone || isInComplianceGrayZone) &&
            dateRequest >= oneMonthAgo
          ) {
            visibleSolicitations.push(solicitation);
          }
        });
        resObject.code = '200';
        resObject.data = visibleSolicitations;
      })
      .catch(error => {
        console.error(error);
        resObject.code = '131';
      });
    return resObject;
  }

  async loadDocument(body: any) {
    const resObject: any = {};
    await this.requestService
      .loadDocument(body)
      .then((res: any) => {
        resObject.data = res;
        resObject.code = '200';
      })
      .catch(error => {
        console.error(error);
        resObject.code = '131';
      });
    return resObject;
  }

  async documentarySufficiency(
    principalActivityId: string,
    operationTarget: string,
  ) {
    const resObject: any = {};
    await this.requestService
      .documentarySufficiency(principalActivityId, operationTarget)
      .then((res: any) => {
        resObject.data = res.data;
        resObject.code = '200';
      })
      .catch(error => {
        console.error(error);
        resObject.code = '131';
      });
    return resObject;
  }

  saveBitacora(eventName: string) {
    const devicePrint = new LogDeviceModel();
    const product_name = this.abreCuentasService.getproductSelected()
      ? this.abreCuentasService.getproductSelected().product_code
      : '';
    devicePrint.device = this.abreCuentasService.getDeviceInfo();
    // const ipBiocatch = this.bioCatchService.getCurrentScoreIp();
    devicePrint.device.event_name = eventName;
    // devicePrint.device.ip = ipBiocatch;
    devicePrint.terms_type = eventName;
    this.requestService.saveDataInBitacora(devicePrint);
  }

  async getPcoAmount() {
    const productSelected = this.abreCuentasService.getproductSelected();
    this.saveBitacora('Ini_loading_PCO');
    return await this.performPco().then(async result => {
      if (result !== '200') {
        return '107';
      }
      await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
      return await this.getChannelComunicator(false, true).then(result2 => {
        if (result2 === '107' || result2 === '121' || result2 === '130' || result2 === '129' || result2 === '124' || result2 === '127') {
          this.saveBitacora('Out_loading_PCO');
          return result2;
        }

        if (result2 === '17') {
          this.saveBitacora('Normalization_yes');
          return ERROR_LIB.CODE;
        } else {
          this.saveBitacora('Out_loading_PCO');
          return result2;
        }
      }).catch(() => '107');
    }).catch(error => {
      console.log('🚀 ~ file: capture.service.ts:2490 ~ CaptureService ~ awaitthis.performPco ~ error:', error);
      return '107';
    });

  }

  formatBirthDate(birthDate: string) {
    const dateFormat = birthDate;
    if (dateFormat.indexOf('/') !== -1) {
      if (dateFormat.split('/')[0].length === 4) {
        birthDate = dateFormat.split('/').join('-');
      } else {
        birthDate = dateFormat.split('/').reverse().join('-');
      }
    }
    return birthDate;
  }
}
